module.exports = __webpack_public_path__ + "img/fr_failure_5.01c09396.png";